import { Box, IconButton, Stack, Typography } from '@mui/material';
import React, { FC, ReactNode, useState } from 'react';
import MuiDialog from '../../../../components/ui-component/mui-dialog/MuiDialog';
import { Delete } from '@mui/icons-material';

interface ComponentFieldBoxProps {
	index: number;
	title: string;
	children: ReactNode;
	showDeleteButton?: boolean;
	onDelete?: () => void;
	dialogTitle?: string;
	dialodContent?: string;
}

const ComponentFieldBox: FC<ComponentFieldBoxProps> = ({
	index,
	title,
	children,
	showDeleteButton = true,
	onDelete,
	dialogTitle,
	dialodContent,
}) => {
	const [openDialog, setOpenDialog] = useState(false);

	const handleOpenDeleteDialog = () => {
		setOpenDialog(true);
	};
	const handleDelete = () => {
		setOpenDialog(false);
		if (onDelete) {
			onDelete();
		}
	};
	return (
		<>
			<MuiDialog
				open={openDialog}
				title={dialogTitle ? dialogTitle : 'Löschen'}
				content={dialodContent ? dialodContent : `Sind Sie sicher, dass Sie diesen Eintrag löschen möchten?`}
				onClose={() => setOpenDialog(false)}
				onConfirm={() => handleDelete()}
			/>
			<Box sx={{ border: '2px solid #e4e4e4', padding: '1rem' }}>
				<Stack direction="row" justifyContent={'space-between'} alignItems={'center'}>
					<Typography variant="h3">
						{' '}
						{title ? title : ''} {index + 1}
					</Typography>
					{showDeleteButton && (
						<IconButton onClick={handleOpenDeleteDialog}>
							<Delete />
						</IconButton>
					)}
				</Stack>
				{children}
			</Box>
		</>
	);
};
export default ComponentFieldBox;
